module.exports = __webpack_public_path__ + "img/SC-6799.df56b101.png";